import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import type { Address } from '@pineapple/address-search';
import PineappleModal from './PineappleModal';

interface UnitPromptModalProps {
  address: Address;
  onSubmit: (unit: string) => void;
  onClose: () => void;
}

/**
 * The building is known but the verdict depends on the unit (Community
 * Fibre qualifies per apartment; a ?locationId= link may name only the
 * building): ask for it and check the address again.
 */
const UnitPromptModal = ({ address, onSubmit, onClose }: UnitPromptModalProps) => {
  const [unit, setUnit] = useState('');
  const submit = () => {
    const cleaned = unit.trim();
    if (cleaned) onSubmit(cleaned);
  };

  return (
    <PineappleModal
      show
      handleClose={onClose}
      footer={(
        <Modal.Footer className="d-flex justify-content-center pt-0">
          <Button
            id="check_address_modal_unit"
            variant="primary"
            size="lg"
            disabled={!unit.trim()}
            onClick={submit}
          >
            <span>Check my unit</span>
          </Button>
        </Modal.Footer>
      )}
    >
      <h1 className="text-center text-primary fw-bold w-100">
        Which unit?
      </h1>
      <p className="lead text-center">
        We found
        {' '}
        <strong>{address.formatted_address}</strong>
        . Availability depends on the apartment, so please tell us your unit number.
      </p>
      <Form
        className="d-flex justify-content-center"
        onSubmit={(e) => { e.preventDefault(); submit(); }}
      >
        <Form.Control
          id="check_address_unit"
          autoFocus
          size="lg"
          className="text-center"
          style={{ maxWidth: 200 }}
          placeholder="e.g. 104"
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
        />
      </Form>
    </PineappleModal>
  );
};

export default UnitPromptModal;
